<template>
  <div class="online-ps">
    <div class="online-ps-header">
      <span>{{getTitle}}</span>
      <i class="iconfont icon-guanbi" @click="close" style="cursor:pointer;"></i>
    </div>
    <left class="left" @setDrawConfig=setDrawConfig :editImgType=editImgType></left>
    <main-content class="main"></main-content>
    <!-- <img :src="src" style="    position: absolute;" alt=""> -->
    <right class="right" :propsData=propsData :layers=layers :fabricObj=fabricObj @renderAll=renderAll :activedFabricObj=activedFabricObj :currentFarbicPar=currentFarbicPar></right>
  </div>
</template>

<script>
import { fabricObject } from './js/fabricOperate'
import right from './right'
import left from './left'
import mainContent from './mainContent'
import ApiService from '@/services/API-services'
import API from '@/config/API-config'
import Vue from 'vue'
import { mapState } from 'vuex'
import axios from 'axios'
export default {
  name: 'onLinePSIndex',
  data() {
    return {
      fabricObj: null,
      num: 1,
      activedFabricObj: null,
      currentFarbicPar: {},
      layers: [],
      loading: null
    }
  },
  props: {
    propsData: Object,
    editImgType: String,
    jsonAddress: String,
    imgBase64: String,
    loadStatus: Number
  },
  created() {
    this.$bus.$on('getAllObjects', this.getLayers)
    this.$bus.$on('getUploaddwg', this.getUploaddwg)
  },
  components: {
    right,
    left,
    mainContent
  },
  computed: {
    ...mapState(['userObj']),
    getTitle() {
      let strTitle = '修改图查看器'
      if (this.editImgType == 'sphere') {
        strTitle = '球标编辑器'
      } else if (this.editImgType == 'sign') {
        strTitle = '标记编辑器'
      }
      return strTitle
    }
  },
  mounted() {
    if (this.propsData) {
      this.startLoading()
      this.fabricObj = fabricObject(this)
      let self = this
      setTimeout(() => {
        if (this.loadStatus == 1) {
          //请求dwg上传的图片
          ApiService.post('api/AMIS/GetDWGData', {
            CID: this.propsData.svgId
          }).then(res => {
            if (res.code == 0) {
              let url = res.data[0].ImageUrl
              // let base64 = this._global.convertImgToBase64(this.uploadDwg)
              this._global.convertImgToBase64(url, res => {
                self.fabricObj.createBGIMG(res, this.endLoading, '')
                this.faricLoadJson()
              })
            } else {
              this.loadSVG()
            }
          })
        }else{
          this.loadSVG()
        }
        // let svgContent = document.getElementById('zoomSvg').outerHTML
        // let href =
        //   'data:image/svg+xml;base64,' +
        //   window.btoa(unescape(encodeURIComponent(svgContent)))
        // let img = new Image()
        // img.src = href
        // img.onload = function() {
        //   var canvas = document.createElement('canvas')
        //   canvas.width = self.fabricObj.fabricObjInst.width
        //   canvas.height = self.fabricObj.fabricObjInst.height
        //   var context = canvas.getContext('2d')
        //   context.drawImage(img, 0, 0)
        //   var imgDataUri = canvas.toDataURL('image/png')
        //   self.src = imgDataUri
        //   self.fabricObj.createBGIMG(imgDataUri, self.endLoading, '')
        //}
        // this.faricLoadJson()
      }, 100)
      // this.fabricObj.createBGSVG(this.propsData.svgUrl,this.startLoading,this.endLoading)
    }
  },
  methods: {
    loadSVG() {
      //加载svg
      let self = this
      let svgContent = document.getElementById('zoomSvg').outerHTML
      let href =
        'data:image/svg+xml;base64,' +
        window.btoa(unescape(encodeURIComponent(svgContent)))
      let img = new Image()
      img.src = href
      img.onload = function() {
        var canvas = document.createElement('canvas')
        canvas.width = self.fabricObj.fabricObjInst.width
        canvas.height = self.fabricObj.fabricObjInst.height
        var context = canvas.getContext('2d')
        context.drawImage(img, 0, 0)
        var imgDataUri = canvas.toDataURL('image/png')
        self.src = imgDataUri
        self.fabricObj.createBGIMG(imgDataUri, self.endLoading, '')
        self.faricLoadJson()
      }
    },
    getUploaddwg(data) {
      this.loadStatus = data
    },
    faricLoadJson() {
      // let json = require('./js/test.json')
      if (this.jsonAddress) {
        this.fabricObj.loadJsonObj(JSON.parse(this.jsonAddress))
      }
    },
    startLoading() {
      this.loading = this._global.loading(this, '正在加载中...')
    },
    endLoading() {
      this.loading.close()
    },
    exportJSONData() {
      let json = this.fabricObj.exportJson()
      return json
    },
    exportPNG() {
      let imgBase64 = this.fabricObj.exportPng()
      if (!imgBase64) {
        imgBase64 = this.dwgIP
      }
      return imgBase64
    },
    close() {
      let imgbase64 = this.exportPNG()
      let jsonStr = this.exportJSONData()
      let params = {
        BasePngStr: imgbase64,
        JsonStr: JSON.stringify(jsonStr),
        CID: this.propsData.svgId,
        Creator: this.userObj.userId,
        Status:this.loadStatus
      }
      ApiService.amis.addPsData(params).then(res => {
        if (res.code == 0) {
          this.$emit('showEditImgFun', false)
          this.$emit('getUploadDwgIp', this.dwgIP)
        }
      })
    },
    setDrawConfig(config) {
      this.fabricObj.setDrawConfig(config)
    },
    getLayers(data) {
      this.layers = []
      data.forEach(element => {
        this.layers.push(Vue.observable(element))
      })
    },
    setActiveObjectCallback() {
      this.activedFabricObj = this.fabricObj.fabricObjInst.getActiveObject()
      this.$set(
        this.currentFarbicPar,
        'left',
        this.activedFabricObj.left * this.activedFabricObj.zoomX
      )
      this.$set(
        this.currentFarbicPar,
        'top',
        this.activedFabricObj.top * this.activedFabricObj.zoomY
      )
      this.$set(this.currentFarbicPar, 'rotate', this.activedFabricObj.angle)
      this.$set(this.currentFarbicPar, 'title', this.activedFabricObj.title)
      this.$set(this.currentFarbicPar, 'type', this.activedFabricObj.type)
      this.$set(this.currentFarbicPar, 'zoomX', this.activedFabricObj.zoomX)
      this.$set(this.currentFarbicPar, 'stroke', this.activedFabricObj.stroke)
      this.$set(this.currentFarbicPar, 'fill', this.activedFabricObj.fill)
      this.$set(this.currentFarbicPar, 'order', this.activedFabricObj.order)
      this.$set(
        this.currentFarbicPar,
        'isGroup',
        this.activedFabricObj.isGroup ? true : false
      )
    },
    renderAll() {
      this.fabricObj.fabricObjInst.renderAll()
    }
  }
}
</script>

<style scoped lang='scss'>
$leftW: 30px;
$rightW: 300px;
$borderColor: #ccc;
$height: calc(100vh - 40px - 80px);
.online-ps {
  width: calc(100vw - 75px);
  background-color: white;
  position: absolute;
  z-index: 2000;
  top: 10px;
  left: 0;
  .online-ps-header {
    font-size: 0.15rem;
    line-height: 0.3rem;
    background-color: #0078d7;
    display: flex;
    justify-content: space-between;
    padding: 5px 15px;
    align-items: center;
    color: white;
  }
}
.left {
  width: $leftW;
  border: 1px solid $borderColor;
  float: left;
  height: $height;
}
.main {
  width: calc(100% - #{$leftW} - #{$rightW} - 3px);
  float: left;
  height: $height;
}
.right {
  width: $rightW;
  border-left: 1px solid $borderColor;
  float: left;
  padding-top: 20px;
  height: calc(#{$height} - 20px);
}
</style>


// WEBPACK FOOTER //
// src/components/editImg/psIndex.vue